import React from "react";
import { Link } from "react-router-dom";
import { can } from "../utils/can";

export const agentColumns = ({ handleEdit,
  handleDelete, PAGE_SIZE, openModal }) => [
    {
      label: "Agent ID",
      width: 100,
      render: (row) =>
        row.agentID ? (<span>#{row.agentID}</span>) : '<span>-</span>',
    },

    {
      label: "Agent Details",
      key: "name",
      width: 250,
      sortable: true,
      render: (row) => (
        <div className="userdet">
          <div>
            <i className="far fa-user" /> {row.name || "-"}
          </div>
          <div>
            <i className="far fa-mobile-alt" /> {row.mobile || "-"}
          </div>
          <div>
            <i className="far fa-envelope" /> {row.email || "-"}
          </div>
          <div style={{ display: "block" }}>
            <strong>Username:</strong> {row.username || row.mobile}
          </div>
          <div style={{ display: "block" }}>
            <strong>Password:</strong> {row.password_show || "******"}
          </div>
        </div>
      ),
    },

    {
      label: "Total Commission",
      width: 120,
      render: (row) => <span>₹ {parseFloat(row.agentCommission?.totalCommission || 0).toFixed(2)}</span>,
    },

    {
      label: "Due Commission",
      width: 120,
      render: (row) => (
        <>
          <span>₹ {parseFloat(row.agentCommission?.commissionPendingAmount || 0).toFixed(2)}</span>
          <br />
          {row.agentCommission?.commissionPendingAmount > 0 && (
            <a
              href={`/admin/agent/pay-commission/${row._id}`}
              className="sitebtn text-white text-center px-1 py-0 mt-2"
              style={{
                fontSize: 12,
                textDecoration: "none",
                display: "inline-block",
                textTransform: "none",
                background: "#db9b0b",
                borderColor: "#db9b0b",
              }}
            >
              Pay Now
            </a>
          )}
        </>
      ),
    },

    {
      label: "All Leads",
      width: 140,
      render: (row) => (
        <>
          <a
            href={`/admin/agent/view-leads/${row._id}`}
            className="sitebtn text-white text-center px-1 py-0 mb-2"
            style={{
              fontSize: 12,
              textDecoration: "none",
              display: "inline-block",
            }}
            onClick={(e) => {
              if (!can("view_lead", "view")) {
                e.preventDefault();
                alert("You don't have permission to view leads.");
              }
            }}
          >
            {row?.totalLeads ?? row.leadCount ?? 0} <i className="fa fa-eye" /> View Leads
          </a>
          <br />
          <a
            href={`/admin/agent/pending-approval-leads/${row._id}`}
            className="sitebtn text-white text-center px-1 py-0 mb-2"
            style={{
              fontSize: 12,
              textDecoration: "none",
              display: "inline-block",
            }}
            onClick={(e) => {
              if (!can("agent_pending_approval_leads", "view")) {
                e.preventDefault();
                alert("You don't have permission to view leads.");
              }
            }}
          >
            <i className="fa fa-eye" /> Pending Approval ({row?.pendingLeadCount ?? 0})
          </a>

        </>
      ),
    },
    {
      label: "Status",
      key: "status",
      width: 120,
      sortable: true,
      render: (row) => (
        <div className="checkbox-wrapper-8">
          <input
            className="tgl tgl-skewed"
            type="checkbox"
            checked={row.status === "Active"}
            readOnly
          />
          <label
            className="tgl-btn"
            data-tg-off="Inactive"
            data-tg-on="Active"
          />
        </div>
      ),
    },

    {
      label: "Actions",
      width: 100,
      render: (row) => (
        <ul className="actionlist">
          <li>
            {can("view_agent", "edit") ? (
              <Link
                to={`/agent/edit-agent/${row._id}`}
                title="Edit Agent"
                onClick={() => handleEdit(row)}
              >
                <i className="fa fa-edit" />
              </Link>
            ) : (
              <button
                title="Edit Agent"
                onClick={() => alert("Action Permission denied")}
              >
                <i className="fa fa-edit" />
              </button>
            )}
          </li>
          <li>

            <button
              title="Delete Agent"
              onClick={() => handleDelete(row._id)}
            >
              <i className="fa fa-trash" />
            </button>
          </li>
        </ul>
      ),
    },

    {
      label: "Documents",
      width: 120,
      render: (row) => (
        <a
          href="#"
          className="sitebtn text-white text-center px-1 py-0"
          style={{
            fontSize: 12,
            textDecoration: "none",
            display: "inline-block",
            textTransform: "none",
          }}
          data-toggle="modal"
          data-target="#documentModal"
          onClick={() => openModal(row)}
        >
          <i className="fa fa-eye" /> View Aadhaar
        </a>
      ),
    },
  ];
